import { useState } from 'react';
import { motion } from 'framer-motion';
import { styles } from './EditCasesModal';

/**
 * Layer 2 override modal — shown when the advisor clicks "Override and
 * upload anyway" after a verification hard-reject. Captures the
 * required override reason and re-submits the cached image.
 */
export default function OverrideUploadModal({ caseIndex, caseLabel, rowError, actionLoading, onCancel, onConfirm }) {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();
  const disabled = !trimmed || actionLoading;

  return (
    <div style={styles.modalOverlay} onClick={() => !actionLoading && onCancel()}>
      <motion.div
        className="card"
        style={styles.modal}
        onClick={(e) => e.stopPropagation()}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <h3 style={{ marginBottom: '0.6rem', color: 'var(--cp-danger)' }}>
          Override verification
        </h3>
        <p style={{ color: 'var(--cp-text)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
          AI verification rejected this upload for <strong>Case {caseIndex + 1}</strong> — “{caseLabel}”.
        </p>
        {rowError && rowError.message && (
          <p style={{ color: 'var(--cp-text-muted)', fontSize: '0.8rem', marginBottom: '0.75rem' }}>
            {rowError.message}
          </p>
        )}
        <p style={{ color: 'var(--cp-text-muted)', fontSize: '0.8rem', marginBottom: '0.6rem' }}>
          Provide a reason for accepting this screenshot anyway. This will be
          recorded in the audit trail with your email.
        </p>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="e.g. Screenshot is correct — client name uses initials in AtWork."
          rows={3}
          style={{ marginBottom: '1rem' }}
          disabled={actionLoading}
        />
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button className="btn btn-outline" onClick={onCancel} disabled={actionLoading}>
            Cancel
          </button>
          <button
            style={styles.confirmDeleteBtn}
            onClick={() => onConfirm(trimmed)}
            disabled={disabled}
          >
            {actionLoading ? 'Uploading…' : 'Override and upload'}
          </button>
        </div>
      </motion.div>
    </div>
  );
}
